import(/* webpackMode: "eager" */ "/app/apps/zyno-customer-ui/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/apps/zyno-customer-ui/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slot"] */ "/app/node_modules/@radix-ui/react-slot/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"../../packages/ui/src/fonts.ts\",\"import\":\"Inter_Tight\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"mainFont\"}");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/command.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/dropdown-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/label.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/popover.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/select.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/separator.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/sheet.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/sidebar.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/switch.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/toggle-group.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/toggle.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/components/tooltip.tsx");
